//var sc = $(this).scrollTop();

function setVw(){
	const vw = document.documentElement.clientWidth / 100;
	document.documentElement.style.setProperty('--vw', `${vw}px`);
}

function disable_scroll(event) {
	event.preventDefault();
  }
  
  $('.l_kv').css('height',$(window).height());
  $('.loading').css('height',$(window).height());

  if(navigator.userAgent.match(/iPhone|Android.+Mobile/)){
	//SP = true
	document.addEventListener('touchmove',disable_scroll,{ passive: false });
	flag = "SP";
  }else{
	//PC = true
	document.addEventListener('mousewheel', disable_scroll, { passive: false });
	flag = "PC";
  };
  
  $(window).on('load',function(){
	$(window).scrollTop(0);
	setVw();
	$("html, body").animate({ scrollTop: 0 }, 1000);
	$('.loading').addClass('_active').delay(4000).fadeOut('fast',function(){
	  if(flag == "PC"){
	  // //PCスクロール禁止解除
	  document.removeEventListener('mousewheel', disable_scroll, { passive: false });
	  };
	  if(flag == "SP"){
	  // //SPスクロール禁止解除
	  document.removeEventListener('touchmove', disable_scroll, { passive: false });
	  }
	});
});
$(function(){

	sc_anm();
	sc_fix();

	$(window).scroll(function() {
		var sc = $(window).scrollTop();
		sc_anm();
		sc_fix();
		/*if(sc < 1) {
			parallax();
		}*/
	});

	function sc_anm() {
		var elem = $('.js-fade');
		elem.each(function () {
			var elemOffset = $(this).offset().top;
			var scrollPos = $(window).scrollTop();
			var wh = $(window).height();
			var ww = $(window).width();

			if($('.p-block').css('display') == 'block') {
				if(scrollPos > elemOffset - wh + (wh * .1) ){// / 1.8
					$(this).addClass('_active');
				}
			} else {
				if(scrollPos > elemOffset - wh + (ww * 0.2) ){// * 0.8
					$(this).addClass('_active');
				}
			}
		});

		var elem2 = $('.sec_5.js-fade_sticky');
		elem2.each(function () {
			var elemOffset = $(this).offset().top;
			var elemOffset2 = $('.sec_4').offset().top;
			var scrollPos = $(window).scrollTop();
			var wh = $(window).height();
			var ww = $(window).width();

			if($('.p-block').css('display') == 'block') {
				if(scrollPos >= elemOffset2 ){
					$(this).addClass('_active');
				}
			} else {
				if(scrollPos > elemOffset - wh + (ww * 0.2) ){
					$(this).addClass('_active');
				}
			}
		});

		var elem3 = $('.sec_8.js-fade_sticky');
		elem3.each(function () {
			var elemOffset = $(this).offset().top;
			var elemOffset2 = $('.sec_7').offset().top;
			var scrollPos = $(window).scrollTop();
			var wh = $(window).height();
			var ww = $(window).width();

			if($('.p-block').css('display') == 'block') {
				if(scrollPos >= elemOffset2 ){
					$(this).addClass('_active');
				}
			} else {
				if(scrollPos > elemOffset - wh + (ww * 0.2) ){
					$(this).addClass('_active');
				}
			}
		});

		var elem4 = $('.sec_19.js-fade_sticky');
		elem4.each(function () {
			var elemOffset = $(this).offset().top;
			var elemOffset2 = $('.sec_18').offset().top;
			var scrollPos = $(window).scrollTop();
			var wh = $(window).height();
			var ww = $(window).width();

			if($('.p-block').css('display') == 'block') {
				if(scrollPos >= elemOffset2 ){
					$(this).addClass('_active');
				}
			} else {
				if(scrollPos > elemOffset - wh + (ww * 0.2) ){
					$(this).addClass('_active');
				}
			}
		});
	}

	function sc_fix() {
		var elem = $('.js-scroll');
		var flg = 0;

		elem.each(function () {
			//var elemOffset = $('.sec_11').offset().top;
			//var elemOffset2 = $('.sec_14').offset().top;
			var scrollPos = $(window).scrollTop();
			var wh = $(window).height();

			if($('.p-block').css('display') == 'block') {
				var elemOffset3 = $('.half-inner_2').offset().top;
				$(this).addClass('_active');
			} else {
				var elemOffset3 = $('.sec_10').offset().top;
				$('.sec_10').removeClass('_active');

			}

			if($('.p-block').css('display') == 'block') {
				if(scrollPos > elemOffset3){
					$(this).addClass('_active');
				}
			} else {
				if(scrollPos > elemOffset3){
					$('.sec_10').addClass('_active');
				}
			}

		});

		/*elem.each(function () {
			var elemOffset = $('.sec_11').offset().top;
			var elemOffset2 = $('.sec_14').offset().top;
			var scrollPos = $(window).scrollTop();
			var wh = $(window).height();

			if(scrollPos > elemOffset - wh){
				if($('.p-block').css('display') == 'block') {
					$(this).addClass('_active').css('bottom', '0');
					$('.sec_11').css('margin-top', '68.3vw');
				} else {
					$(this).addClass('_active').css('bottom', '0');
					$('.sec_11').css('margin-top', '246.1vw');
				}
			} else {
				$(this).removeClass('_active');
				$('.sec_11').css('margin-top', '0');
			}
			if(scrollPos > elemOffset2 - wh){
				$(this).hide();
			} else {
				$(this).show();
			}
		});*/
	}

});

$(window).on('load resize', function(){

	setVw();

	$('.l_kv').css('height',$(window).height());

	if($('.p-block').css('display') == 'block') {} else {
		$('.group3').removeClass('_active');
	}

	var h = $(window).height();

	setTimeout(function(){
		const image = document.getElementsByClassName('thumbnail');
		new simpleParallax(image, {
			overflow: true,
			orientation: "down",
			scale: 1.5,
		});
		const image2 = document.getElementsByClassName('thumbnail2');
		new simpleParallax(image2, {
			overflow: true,
			orientation: "down",
			scale: 1.3,
		});
		const image3 = document.getElementsByClassName('thumbnail3');
		new simpleParallax(image3, {
			overflow: true,
			orientation: "down",
			scale: 1.3,
		});
	},500);
});

$(window).on('load', function() {
	setVw();
	setTimeout(function(){
		$('body,.l_container,.l_kv').addClass("_active");
	},500);
	//parallax();
	$('.slider_1,.slider_4').slick({
		dots: false,
		infinite: true,
		speed: 0,
		autoplaySpeed: 2000,
		fade: false,
		cssEase: 'linear',
		arrows: false,
		autoplay: true,
		pauseOnFocus: false,
		pauseOnHover: false,
		pauseOnDotsHover: false
	});
	$('.slider_1,.slider_4').css('pointer-events', 'none');
});

function parallax() {
	const image = document.getElementsByClassName('thumbnail');
	new simpleParallax(image, {
		overflow: true,
		orientation: "down",
		scale: 1.5,
	});
	document.addEventListener("DOMContentLoaded", function () {
		const elem = document.querySelector(".thumbnail");
		if (elem !== null) {
			let target = document.getElementsByClassName("thumbnail"); 
			let parallaxConfig = {
				delay: 0,
				orientation: "down",
				overflow: true,
				scale: 1.5   
			};
			const parallax_instance = new simpleParallax(target, parallaxConfig);
		}
	});
	const image2 = document.getElementsByClassName('thumbnail2');
	new simpleParallax(image2, {
		overflow: true,
		orientation: "down",
		scale: 1.3,
	});
	const image3 = document.getElementsByClassName('thumbnail3');
	new simpleParallax(image3, {
		overflow: true,
		orientation: "down",
		scale: 1.3,
	});
}
